import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import DirectContactMap from "./sections/DirectContactMap";
import BookingEmbed from "./sections/BookingEmbed";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <DirectContactMap />
      <BookingEmbed />
      <Footer />
    </div>;
}